module.exports = {"id":"dp2_1l3q3","text":"Interacting Through Digital Technologies","instructions":"Which situation best suits synchronous digital communication?","multiselect":false,"questionType":"PickOne","random":true,"options":[{"id":"dp2_1l3q3-a1","text":"Real-time problem solving meeting","score":3.7},{"id":"dp2_1l3q3-a2","text":"Document review over several days","score":1.3},{"id":"dp2_1l3q3-a3","text":"Posting an online announcement","score":1.3}],"groupTitle":"Digital Profiler Knowledge Matrix","category":"2.1"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.1/l3q3.json
// module id = 994
// module chunks = 41